import React, {
  MutableRefObject,
  RefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Select, Tooltip, Typography } from 'antd';
import * as _ from 'lodash';
import { LoadingContainer } from 'app/components/LoadingContainer';
import useWindowSize from 'app/hooks/useWindowSize';
import moment from 'moment';

import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import {
  GET_PARKS,
  GET_PERFORMANCES,
  GET_RESTAURANTS,
  GET_ZONES,
  useHomeSlice,
} from 'app/pages/Home/slice';
import {
  selectListPark,
  selectListZone,
  selectListPerformance,
  selectListRestaurant,
} from 'app/pages/Home/slice/selectors';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import { useDispatch, useSelector } from 'react-redux';
import { I_OptionsGetList } from 'types';
import { Layout } from '../layouts';
import StyledTable from 'app/components/StyledTable';
import { DesktopSearchComponent } from './HeaderFilter';
import { GET_TICKETS, useCheckTicketSlice } from './slice';
import {
  selectListTicket,
  selectMaxFileReleaseTicket,
  selectPaginator,
} from './slice/selectors';
import StyledGradientDivider from 'app/components/StyledGradientDivider';
import StyledPagination from 'app/components/StyledPagination';
import StatusComponent, { StatusState } from 'app/components/StatusComponent';
import CustomerInfoModal from './CustomerInfoModal';
import { ActionComponent } from './HeaderAction';
import { ReactComponent as IssuancedTicketIcon } from 'app/assets/img/ticket-issused-icon.svg';
import { ReactComponent as UnIssuanedTicketIcon } from 'app/assets/img/ticket-unissused-icon.svg';
import { ReactComponent as SortASC } from 'app/assets/img/sort-asc-icon.svg';
import { ReactComponent as SortDESC } from 'app/assets/img/sort-desc-icon.svg';
import { ReactComponent as SortDefault } from 'app/assets/img/sort-default-icon.svg';
import { ReactComponent as ErrorTriangleIcon } from 'app/assets/img/error-triangle-icon.svg';

import {
  cancelTicketApi,
  exportExcelApi,
  preExchangeTicketApi,
  getRefundTicketsApi,
  releaseTicketApi,
  synStatusTicketApi,
  updateCustomerTicketApi,
} from 'app/services/checkTicketApi';
import DialogWarning from 'app/pages/Catalog/components/DialogWarning';
import useGetDetailTicket from '../hooks/useGetDetailTicket';
import { DesktopSearchMobileComponent } from './HeaderFilterMobile';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import EmptyDataView from 'app/pages/NewAccount/CheckTickets/EmpyDataView';
import { useCommonSlice } from 'utils/hooks/useReduceCommon';
import DialogCondition from './DialogCondition';
import StyledButton from 'app/components/StyledButton';
import Images from 'app/assets/img';
import { notify } from 'reapop';
import { StringStatus, listOrderTypeStr, listStatus } from './helper';
import { Switch, useHistory, useLocation } from 'react-router-dom';
import { ProtectedRoute } from 'app/components/RouteGuard';
import UpdateTicket from './UpgradeTickets';
import UpdateSummary from './UpgradeSummary';
import { setSessionItem } from 'utils/localStorage';
import {
  BP_TYPE,
  REFUND_TICKETS_ALLOCATED_DEBT,
  TYPE_LOCAL_STORAGE,
} from 'utils/constants';
import { ReactComponent as TicketRefundIcon } from 'app/assets/img/ticket-refund-icon.svg';
import { ReactComponent as TicketRefundInactiveIcon } from 'app/assets/img/ticket-refund-icon-inactive-gray.svg';
import { ReactComponent as TicketUpgradeIcon } from 'app/assets/img/ticket-upgrade-icon.svg';
import { ReactComponent as TicketUpgradeInactiveIcon } from 'app/assets/img/ticket-upgrade-inactive-icon.svg';
import { ReactComponent as TicketInfoIcon } from 'app/assets/img/ticket-info-icon.svg';
import { REFUND_TICKETS_SELECTED } from 'utils/constants';
import ErrMsg from '../components/ErrMsg';
import TicketExpiredModal from './TicketExchangeExpiredModal';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  findIntersection,
  formatTimeFrame,
  getFromDateToDate,
} from 'utils/helper';
import useGetApiData from 'app/hooks/useGetApiData';
import { getListGroupCodeApi } from 'app/services/homeApi';
import useTitleSize from 'app/components/StyledTable/useTitleSize';
import { Permission } from 'app/hooks/usePermission';
import { ORDER_SOURCES } from '../PurchaseHistory';

export enum TICKET_STATUS {
  UNUSE = '0',
  USED = '1',
  OUTDATE = '2',
  PENDING_CANCELLATION = '3',
  CANCELLED = '4',
  WAITING_REFUND = '5',
  REFUND_EXPIRED = '6',
  REISSUED = '7',
}

const CheckTicketComponent = () => {
  const searchText = useRef('');
  const dispatch = useDispatch();
  const translations = useSelector(selectTranslations);
  const searchCancel =
    useRef<{ search: (params: Partial<I_OptionsGetList>) => void }>(null);
  const { actions: checkTicketActions } = useCheckTicketSlice();
  const { actions: commonActions } = useCommonSlice();
  const history = useHistory();
  const { state, pathname } = useLocation<any>();
  const [loading, setLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isShowTicketExpired, setIsShowTicketExpired] = useState(false);
  const [isReadOnlyCustomerInfo, setIsReadOnlyCustomerInfo] = useState(false);
  const [resetSelected, setResetSelected] = useState(false);
  const [updateInfoTicketId, setUpdateInfoTicketId] = useState(null);
  const selectedTicketRef: any = useRef({});
  const selectedOneTicketRef: any = useRef({});
  let listTickets = useSelector(selectListTicket);
  const paginator = useSelector(selectPaginator);
  const maxFileReleaseTicket = useSelector(selectMaxFileReleaseTicket);
  const infoUser = useSelector(selectInfoUser);
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const formatString = 'HH:mm:ss DD/MM/YYYY';
  const [initCustomerInfo, setInitCustomerInfo] = useState<any>(null);
  const [errMsg, setErrMsg] = useState('');

  const [ticketDetail, setTicketDetail] = useState<any>(null);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();

  const { onClickShowDetail } = useGetDetailTicket({
    screen: '/check-tickets',
    setIsLoading: setLoading,
  });
  const { executeRecaptcha } = useGoogleReCaptcha();
  interface I_filter {
    page: number;
    park?: Number | String;
    orderDate?: String;
    searchOrderId?: String;
    limit: number;
    product_id?: String | Number;
    agent?: Number | String;
    status?: Number | String;
    orderBy?: String;
    orderType?: String;
    vgsUsageDateToSearch?: String;
    zoneId?: Number;
    restaurantId?: Number;
    performanceTime?: String;
    areaType?: Number[];
    ageType?: Number[];
    orderTypeStr?: String;
    orderDateTo?: String;
    orderDateFrom?: String;
    expiredDateTo?: string;
    expiredDateFrom?: string;
    groupCode?: string;
    type?: ('NORMAL' | 'FOC' | 'NORMAL_GIFT')[];
    bpAllocatedDebt?: number | string;
    orderSource?: ORDER_SOURCES;
  }

  const initFilter = {
    page: 1,
    limit: 20,
    orderBy: 'orderDate',
    orderType: 'DESC',
    areaType: [],
    ageType: [],
    expiredDateFrom: moment().format('YYYY-MM-DD'),
    expiredDateTo: moment().add(30, 'days').format('YYYY-MM-DD'),
  };
  const [filters, setFilters] = useState<I_filter>(initFilter);
  const [warningDialogMsg, setWarningDialogMsg] = useState('');
  const [dialogCondition, setDialogCondition] = useState({
    isShow: false,
    content: '',
  });
  const [isResetFrom, setIsResetFrom] = useState(false);
  useHomeSlice();
  const { device } = useWindowSize();

  const listPark = useSelector(selectListPark);
  // const listZoneReduce = useSelector(selectListZone);
  const listRestaurantReduce = useSelector(selectListRestaurant);
  const listPerformanceReduce = useSelector(selectListPerformance);
  const { data: listGroupCodeData } = useGetApiData({
    api: getListGroupCodeApi,
  });

  const listGroupCode = useMemo(() => {
    return listGroupCodeData?.data?.map(item => ({
      label: item?.groupCode || '',
      value: item?.value || '',
    }));
  }, [listGroupCodeData]);

  const ticketTypeOptions = useMemo(
    () => [
      { label: translations?.['b2b.txt.ticket-normal'] ?? '', value: 'NORMAL' },
      {
        label: translations?.['b2b.txt.ticket-normal-gift'] ?? '',
        value: 'NORMAL_GIFT',
      },
      { label: translations?.['b2b.txt.ticket-foc'] ?? '', value: 'FOC' },
    ],
    [translations],
  );

  const convertTicketType = useCallback(
    (ticketType: 'NORMAL' | 'NORMAL_GIFT' | 'FOC') => {
      return ticketTypeOptions.find(type => type.value === ticketType)?.label;
    },
    [ticketTypeOptions],
  );

  const StringStatus = (status: string) => {
    if (status === TICKET_STATUS.UNUSE) return 'UNUSE';
    if (status === TICKET_STATUS.USED) return 'USED';
    if (status === TICKET_STATUS.OUTDATE) return 'OUTDATE';
    if (status === TICKET_STATUS.PENDING_CANCELLATION)
      return 'PENDING_CANCELLATION';
    if (status === TICKET_STATUS.CANCELLED) return 'CANCELLED';
    if (status === TICKET_STATUS.WAITING_REFUND) return 'WAITING_REFUND';
    if (status === TICKET_STATUS.REFUND_EXPIRED) return 'REFUND_EXPIRED';
    if (status === TICKET_STATUS.REFUND_EXPIRED) return 'REFUND_EXPIRED';
    if (status === TICKET_STATUS.REISSUED) return 'REISSUED';
    return '';
  };

  const travelLocation = useMemo(() => {
    return [
      ...[{ value: 'All', label: translations?.['b2b.text.all'] }],
      ...listPark?.map(item => ({
        value: `${item.id}`,
        label: item.name,
      })),
    ];
  }, [listPark, translations]);

  // const listZone = useMemo(() => {
  //   if (_.isEmpty(listZoneReduce)) return [];
  //   return [
  //     ...listZoneReduce?.map(item => ({
  //       value: `${item.id}`,
  //       label: item.name,
  //     })),
  //   ];
  // }, [listZoneReduce]);

  const listRestaurant = useMemo(() => {
    if (_.isEmpty(listRestaurantReduce)) return [];
    return [
      ...listRestaurantReduce?.map(item => ({
        value: `${item.id}`,
        label: item.name,
      })),
    ];
  }, [listRestaurantReduce]);

  const listPerformance = useMemo(() => {
    if (_.isEmpty(listPerformanceReduce)) return [];

    return [
      ...listPerformanceReduce?.map(item => ({
        value: item,
        label: formatTimeFrame(item),
      })),
    ];
  }, [listPerformanceReduce]);

  const onCloseDialog = () => {
    setIsShow(false);
    setIsShowTicketExpired(false);
    setTicketDetail(null);
    setInitCustomerInfo(null);
    selectedOneTicketRef.current = null;
    setUpdateInfoTicketId(null);
    setDialogCondition({
      isShow: false,
      content: '',
    });
  };

  const onSumitRelease = async (valuesForm: any) => {
    try {
      setIsShow(false);
      setLoading(true);
      const isRelease =
        selectedTicketRef.current?.isActive ||
        !_.isEmpty(selectedOneTicketRef?.current);
      if (isRelease) {
        let selectedTickets = selectedTicketRef?.current?.selectedTickets;
        if (!_.isEmpty(selectedOneTicketRef?.current)) {
          selectedTickets = [selectedOneTicketRef?.current];
        }
        const ownTickets = selectedTickets.filter(
          ticket =>
            isSaleMng ||
            ticket.agent?.id === infoUser?.id ||
            (!!ticket?.businessPartnerAllocatedDebt?.id && !isProxyBuyer),
        );
        const fromData = new FormData();
        if (_.isArray(ownTickets) && ownTickets.length > 0) {
          if (ownTickets.length === 1 && valuesForm.isShowDownload === '0') {
            await onUpdateCustomerInfo(valuesForm, ownTickets?.[0]?.id);
            return;
          }
          ownTickets.forEach((ticket: any, index) => {
            fromData.append(`tickets[${index}][id]`, ticket.id);
            fromData.append(`tickets[${index}][orderId]`, ticket.orderId);
            fromData.append(
              `tickets[${index}][orderItemId]`,
              ticket.orderItemId,
            );
            fromData.append(`tickets[${index}][ticketCode]`, ticket.ticketCode);
          });

          if (ownTickets?.[0]?.isLongTerm) {
            fromData.append(`isLongTerm`, '1');
          }
          Object.keys(valuesForm).forEach(key => {
            fromData.append(key, valuesForm[key]);
          });
          const resReleaseTicket = await releaseTicketApi(fromData);
          if (resReleaseTicket?.status === 200) {
            // success
            selectedTicketRef.current = {
              isActive: false,
              selectedTickets: [],
            };
            getData(filters);
            onCloseDialog();
          } else {
            // error
          }
        } else {
          setWarningDialogMsg(
            translations
              ? translations['b2b.txt.realease-ticket-required']
              : '',
          );
        }
      } else {
        await onUpdateCustomerInfo(valuesForm);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const checkDifferent = arr => {
    return new Set(arr).size !== 1;
  };

  const onUpgradeTicket = async (ticketInfo: any = null) => {
    if (!executeRecaptcha) return;
    try {
      setLoading(true);
      const tokenCaptcha = await executeRecaptcha();
      setErrMsg('');
      if (selectedTicketRef.current?.isActive || !_.isEmpty(ticketInfo)) {
        let selectedTickets = selectedTicketRef?.current?.selectedTickets;
        if (!_.isEmpty(ticketInfo)) {
          selectedTickets = [ticketInfo];
        }
        const ownTickets = selectedTickets.filter(
          ticket => ticket.agent?.id === infoUser?.id,
        );
        const ticketsToUpgrade = isSaleMng ? selectedTickets : ownTickets;
        const fromData = new FormData();
        fromData.append('captcha', tokenCaptcha);
        if (_.isArray(selectedTickets) && selectedTickets.length > 0) {
          if (!ticketsToUpgrade.length) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.warning-check-tickets-upgrade']
                : '',
            );
            return false;
          }

          const isDiffOrder = checkDifferent(
            ticketsToUpgrade.map(ticket => ticket?.orderId),
          );
          if (isDiffOrder) {
            setWarningDialogMsg(
              translations?.['b2b.txt.plsSelectTicketSameOrder'],
            );
            return;
          }
          const isDiffPark = checkDifferent(
            ticketsToUpgrade.map(ticket => ticket?.park?.id),
          );
          if (isDiffPark) {
            setWarningDialogMsg(
              translations?.['b2b.txt.plsSelectTicketSamePark'],
            );
            return;
          }
          const isDiffGroup = findIntersection(
            ...(ticketsToUpgrade?.map(ticket =>
              (ticket?.show?.groupCode || '')?.split(','),
            ) || []),
          );

          if (!isDiffGroup.length) {
            setWarningDialogMsg(
              translations?.['b2b.txt.plsSelectTicketSameGroup'],
            );
            return;
          }
          const isSomeTicketExpired = ticketsToUpgrade.some(
            ticket => ticket?.status === TICKET_STATUS.OUTDATE,
          );
          if (isSomeTicketExpired) {
            setWarningDialogMsg(
              translations?.['b2b.txt.upgradeTicketNotForExpiredTicket'],
            );
            return;
          }
          const isSomeTicketUsed = ticketsToUpgrade.some(
            ticket => ticket?.status === TICKET_STATUS.USED,
          );
          if (isSomeTicketUsed) {
            setWarningDialogMsg(
              translations?.['b2b.txt.upgradeTicketNotForUsedTicket'],
            );
            return;
          }
          const isSomeInvalidTicket = ticketsToUpgrade.some(
            ticket => ticket?.status !== TICKET_STATUS.UNUSE,
          );
          if (isSomeInvalidTicket) {
            setWarningDialogMsg(
              translations?.['b2b.txt.plsSelectValidTicketToUpgrade'],
            );
            return;
          }
          if (checkAnyFreegoodOrFOC(ticketsToUpgrade)) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.featureNotApplyFreegoodOrFOC']
                : '',
            );
            return false;
          }
          if (!checkIsValidProxyOrder(ticketsToUpgrade)) {
            setWarningDialogMsg(
              translations ? translations['b2b.txt.invalidTicketPlsAgain'] : '',
            );
            return false;
          }
          if (
            ticketsToUpgrade?.some(i => i?.status === TICKET_STATUS.REISSUED)
          ) {
            setWarningDialogMsg(translations?.['b2b.txt.reissueNoExchange']);
            return;
          }
          ticketsToUpgrade.forEach((ticket: any, index: number) => {
            fromData.append(`cancelItems[${index}][ticket_id]`, ticket.id);
            fromData.append(
              `cancelItems[${index}][item_id]`,
              ticket.orderItemId,
            );
            fromData.append(`cancelItems[${index}][order_id]`, ticket.orderId);
          });

          const bpAllocatedDebt =
            ticketsToUpgrade?.[0]?.businessPartnerAllocatedDebt?.id;
          if (bpAllocatedDebt !== null && bpAllocatedDebt !== undefined)
            fromData.append('bpAllocatedDebt', bpAllocatedDebt);
          const resExchangeTicket: any = await preExchangeTicketApi(fromData);
          if (resExchangeTicket?.status === 200) {
            // success
            history.push({
              pathname: `/check-tickets/select-tickets/${resExchangeTicket?.data.idHash}`,
            });
            getData(filters);
            return;
          } else {
          }
        } else {
          setWarningDialogMsg(
            translations ? translations['b2b.txt.upgrade-ticket-require'] : '',
          );
        }
      } else {
        setWarningDialogMsg(
          translations ? translations['b2b.txt.upgrade-ticket-require'] : '',
        );
      }
    } catch (error: any) {
      if (error?.status === 500) {
        setWarningDialogMsg(error?.title);
      } else if (error?.message) {
        if (error?.data?.errorCode === 'TICKET_CANNOT_CHANGE') {
          const message = error?.data?.ticketNames
            ?.map(name => `+ ${name}`)
            .join('\n');
          setWarningDialogMsg(
            `${
              translations?.['b2b.txt.ticket-can-not-change'] || ''
            }\n${message}`,
          );
          return;
        }
        setWarningDialogMsg(error?.message);
        if (error?.data?.needReload) {
          getData({
            ...filters,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const checkTicketsFormSameOrder = (ticketSelected: any[]) => {
    const firstTicketOrderId = ticketSelected?.[0]?.orderId;
    return !ticketSelected.some(
      ticket => ticket.orderId !== firstTicketOrderId,
    );
  };

  const checkTicketsFormSamePark = (ticketSelected: any[]) => {
    const firstParkId = ticketSelected[0]?.park?.id;
    return !ticketSelected.some(ticket => ticket?.park?.id !== firstParkId);
  };

  const checkIsValidProxyOrder = (ticketSelected: any[]) => {
    return !ticketSelected?.some(ticket => {
      const isProxyOrder = !!ticket?.businessPartnerAllocatedDebt?.id;
      return isProxyOrder && !isProxyBuyer;
    });
  };

  const checkValidTicketStatusToRefund = (ticketSelected: any[]) => {
    return !ticketSelected.some(
      ticket =>
        ticket.status !== TICKET_STATUS.UNUSE &&
        ticket.status !== TICKET_STATUS.OUTDATE,
    );
  };

  const checkValidTicketUsed = (ticketSelected: any[]) => {
    return ticketSelected.some(ticket => ticket.status === TICKET_STATUS.USED);
  };

  const checkAllTicketsHasAgentId = (ticketSelected: any[], agentId: any) => {
    return ticketSelected.every(ticket => ticket.agent?.id === agentId);
  };

  const checkAnyTicketsHasAgentId = (ticketSelected: any[], agentId: any) => {
    return ticketSelected.some(ticket => ticket.agent?.id === agentId);
  };

  const checkAnyFreegoodOrFOC = (ticketSelected: any[]) => {
    return ticketSelected.some(
      ticket =>
        ticket?.ticketType === 'FOC' || ticket?.ticketType === 'NORMAL_GIFT',
    );
  };

  const onRefundTicket = async isRowAction => {
    setLoading(true);
    try {
      if (
        selectedTicketRef.current?.isActive ||
        !_.isEmpty(selectedOneTicketRef?.current)
      ) {
        const selectedTickets = isRowAction
          ? [selectedOneTicketRef?.current]
          : selectedTicketRef?.current?.selectedTickets;

        const ownTickets = selectedTickets.filter(
          ticket => ticket.agent?.id === infoUser?.id,
        );

        const ticketsToRefund = isSaleMng ? selectedTickets : ownTickets;

        const formData = new FormData();
        if (_.isArray(selectedTickets) && selectedTickets.length > 0) {
          if (!ticketsToRefund.length) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.warning-check-tickets-refund']
                : '',
            );
            return false;
          }
          if (!checkTicketsFormSameOrder(ticketsToRefund)) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.plsSelectTicketSameOrder']
                : '',
            );
            return false;
          }
          if (!checkTicketsFormSamePark(ticketsToRefund)) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.plsSelectTicketSamePark']
                : '',
            );
            return false;
          }
          if (
            !checkAllTicketsHasAgentId(ticketsToRefund, infoUser?.id) &&
            !isSaleMng
          ) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.warning-check-tickets-refund']
                : '',
            );
            return false;
          }
          if (checkAnyFreegoodOrFOC(ticketsToRefund)) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.featureNotApplyFreegoodOrFOC']
                : '',
            );
            return false;
          }
          if (!checkIsValidProxyOrder(ticketsToRefund)) {
            setWarningDialogMsg(
              translations ? translations['b2b.txt.invalidTicketPlsAgain'] : '',
            );
            return false;
          }
          if (
            ticketsToRefund?.some(i => i?.status === TICKET_STATUS.REISSUED)
          ) {
            setWarningDialogMsg(translations?.['b2b.txt.reissueNoCancel']);
            return;
          }
          const bpAllocatedDebt =
            ticketsToRefund?.[0]?.businessPartnerAllocatedDebt?.id;
          if (bpAllocatedDebt !== null && bpAllocatedDebt !== undefined)
            formData.append('bpAllocatedDebt', bpAllocatedDebt);
          ticketsToRefund.forEach((ticket: any) => {
            formData.append('tickets[]', ticket.id);
          });
          const resRefundTicket = await getRefundTicketsApi(formData);
          const refundTicketData = resRefundTicket.data.data;
          if (resRefundTicket?.status === 200) {
            if (!checkValidTicketStatusToRefund(refundTicketData)) {
              setWarningDialogMsg(
                translations?.['b2b.txt.plsSelectValidTicketToRefund'] ?? '',
              );
              getData(filters);
              return;
            } else if (checkValidTicketUsed(refundTicketData)) {
              setWarningDialogMsg(
                translations?.['b2b.txt.ticketHasBeenUsed'] ?? '',
              );
              getData(filters);
              return;
            }
            sessionStorage.setItem(
              REFUND_TICKETS_SELECTED,
              selectedTickets.map(i => i.id).join(','),
            );
            if (bpAllocatedDebt !== null && bpAllocatedDebt !== undefined)
              sessionStorage.setItem(
                REFUND_TICKETS_ALLOCATED_DEBT,
                bpAllocatedDebt,
              );
            history.push(`/ticket-refund`, {
              refundTicketData: resRefundTicket.data.data,
              businessPartnerData: resRefundTicket.data.businessPartner,
              isErrorMinMaxConfig:
                resRefundTicket?.data?.isErrorMinMaxConfig || false,
            });
          } else {
            // error
          }
        } else {
          setWarningDialogMsg(
            translations?.['b2b.txt.refund-ticket-require'] ?? '',
          );
        }
      } else {
        setWarningDialogMsg(
          translations?.['b2b.txt.refund-ticket-require'] ?? '',
        );
      }
    } catch (error: any) {
      if (error?.data?.errorCode === 'TICKET_CANNOT_REFUND') {
        const message = error?.data?.ticketNames
          ?.map(ticket =>
            translations?.['b2b.txt.ticketCannotRefund']?.replace(
              '${name}',
              ticket?.name || '',
            ),
          )
          .join('\n');
        setWarningDialogMsg(message);
        return;
      }
      setWarningDialogMsg(error?.message);
      if (error?.data?.needReload) {
        getData({
          ...filters,
        });
      }
    } finally {
      selectedOneTicketRef.current = null;
      setLoading(false);
    }
  };

  const onSelect = async (values: any) => {
    setResetSelected(false);
    selectedTicketRef.current = {
      isActive: !_.isEmpty(values),
      selectedTickets: values,
    };
  };

  const onUpdateCustomerInfo = async (customerInfo: any, updateId?: number) => {
    const fromData = new FormData();
    fromData.append(
      'tickets[]',
      String(!_.isNil(updateId) ? updateId : updateInfoTicketId),
    );
    Object.keys(customerInfo).forEach(key => {
      fromData.append(key, customerInfo[key]);
    });
    const resUpdateCustomeInfo = await updateCustomerTicketApi(fromData);
    if (resUpdateCustomeInfo?.status === 200) {
      // success
      getData(filters);
      onCloseDialog();
    } else {
      // error
    }
  };

  const handleCancelTicket = async () => {
    setLoading(true);
    try {
      if (
        selectedTicketRef.current?.isActive ||
        !_.isEmpty(selectedOneTicketRef?.current)
      ) {
        let selectedTickets = selectedTicketRef?.current?.selectedTickets;
        if (!_.isEmpty(selectedOneTicketRef?.current)) {
          selectedTickets = [selectedOneTicketRef?.current];
        }
        const fromData = new FormData();
        if (_.isArray(selectedTickets) && selectedTickets.length > 0) {
          const findTicketIssoled = selectedTickets.find(
            ticket => +ticket?.issueStatus === 1,
          );
          if (_.isEmpty(findTicketIssoled)) {
            setWarningDialogMsg(
              translations
                ? translations['b2b.txt.cancled-ticket-require']
                : '',
            );
            return;
          }
          selectedTickets.forEach((ticket: any) =>
            fromData.append('tickets[]', ticket.id),
          );
          const resCancelTicket = await cancelTicketApi(fromData);
          if (resCancelTicket?.status === 200) {
            // success
            onSelect([]);
            getData(filters);
          } else {
            // error
          }
        } else {
          setWarningDialogMsg(
            translations ? translations['b2b.txt.cancled-ticket-require'] : '',
          );
        }
      } else {
        setWarningDialogMsg(
          translations ? translations['b2b.txt.cancled-ticket-require'] : '',
        );
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleSynTicketStatus = async () => {
    setLoading(true);
    try {
      if (selectedTicketRef.current?.isActive) {
        const fromData = new FormData();
        let selectedTickets = selectedTicketRef?.current?.selectedTickets;
        selectedTickets.forEach((ticket: any) =>
          fromData.append('tickets[]', ticket.id),
        );
        const resSynStatus = await synStatusTicketApi(fromData);
        if (resSynStatus?.status === 200) {
          onSelect([]);
          getData(filters);
          dispatch(
            notify(
              translations
                ? translations['b2b.txt.syn-ticket-success']
                : 'Thành công.',
              'success',
              {
                title: 'Success',
                dismissAfter: 2000,
              },
            ),
          );
        } else {
        }
      } else {
        setWarningDialogMsg(
          translations ? translations['b2b.txt.syn-ticket-status-require'] : '',
        );
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onOpenCustomerInfo = async (
    ticketInfo: any = null,
    type: string = '',
  ) => {
    let _paramTicket = ticketInfo;
    if (
      type === 'release' &&
      _.isEmpty(ticketInfo) &&
      !selectedTicketRef.current?.isActive
    ) {
      // click release and not select
      setWarningDialogMsg(
        translations ? translations['b2b.txt.realease-ticket-required'] : '',
      );
      return;
    }

    const ownTickets = selectedTicketRef?.current?.selectedTickets.filter(
      ticket =>
        isSaleMng ||
        ticket.agent?.id === infoUser?.id ||
        (!!ticket?.businessPartnerAllocatedDebt?.id && !isProxyBuyer),
    );

    if (ownTickets?.filter(item => item?.isLongTerm)?.length > 0) {
      // fromData.append(`isLongTerm`, '1');
      setWarningDialogMsg(
        translations
          ? translations['b2b.txt.error-issue-long-term-tickets']
          : '',
      );
      return;
    }

    if (
      ownTickets.length > (maxFileReleaseTicket ?? 0) &&
      !ownTickets?.[0]?.isLongTerm
    ) {
      setWarningDialogMsg(
        translations?.['b2b.ticket.max-ticket-release']?.replace(
          '${number}',
          `${maxFileReleaseTicket ?? 0}`,
        ),
      );
      return;
    }

    if (
      type === 'release' &&
      _.isEmpty(ticketInfo) &&
      selectedTicketRef.current?.isActive
    ) {
      if (!ownTickets.length) {
        setWarningDialogMsg(
          translations
            ? translations['b2b.txt.warning-check-tickets-issue']
            : '',
        );
        return;
      }
      const isDiffOrder = checkDifferent(
        ownTickets.map(ticket => ticket?.orderId),
      );
      if (isDiffOrder) {
        setWarningDialogMsg(translations?.['b2b.txt.plsSelectTicketSameOrder']);
        return;
      }
      // check selected ticked unused
      const findTicketNotUsed = ownTickets.find(
        ticket => +ticket?.status === 0,
      );
      if (_.isEmpty(findTicketNotUsed)) {
        setWarningDialogMsg(
          translations
            ? translations['b2b.txt.upgrade-ticket-invalid-error']
            : '',
        );
        return;
      }
      // check selected ticked unused
      const findTickeUsed = ownTickets.find(ticket => +ticket?.status !== 0);
      if (!_.isEmpty(findTickeUsed)) {
        setWarningDialogMsg(
          translations
            ? translations['b2b.txt.upgrade-ticket-invalid-error']
            : '',
        );
        return;
      }
      // click realse and had select box
      const findTicketIssoled = ownTickets.find(
        ticket => +ticket?.issueStatus === 1,
      );
      if (!_.isEmpty(findTicketIssoled)) {
        // warning replace custom info
        setIsReadOnlyCustomerInfo(false);
        setDialogCondition({
          isShow: true,
          content: translations
            ? translations['b2b.warning-ticket-replace-info-customer']
            : '',
        });
        return;
      }
      const findFirstTicketIssoled = ownTickets[0];
      _paramTicket = findFirstTicketIssoled;
    }

    setInitCustomerInfo({
      customerName: _paramTicket?.customerName || '',
      customerEmail: _paramTicket?.customerEmail || '',
      customerPhone: _paramTicket?.customerPhone || '',
      note: _paramTicket?.note || '',
    });

    setIsShow(!isShow);

    if (
      _paramTicket?.status !== TICKET_STATUS.UNUSE ||
      +_paramTicket?.issueStatus === 1
    )
      setIsReadOnlyCustomerInfo(true);
    else {
      const isProxyOrder = !!_paramTicket?.businessPartnerAllocatedDebt?.id;

      if ((isProxyOrder && !isProxyBuyer) || isSaleMng)
        setIsReadOnlyCustomerInfo(false);
      else setIsReadOnlyCustomerInfo(_paramTicket?.agent?.id !== infoUser?.id);
    }
  };

  const onConfirmReplace = () => {
    const _paramTicket: any = selectedTicketRef?.current?.selectedTickets[0];
    setInitCustomerInfo({
      customerName: _paramTicket?.customerName || '',
      customerEmail: _paramTicket?.customerEmail || '',
      customerPhone: _paramTicket?.customerPhone || '',
      note: _paramTicket?.note || '',
    });
    setDialogCondition({
      isShow: false,
      content: '',
    });
    setIsShow(!isShow);
  };

  const handleSelectedAndReleaseTicket = async (ticketInfo: any) => {
    selectedOneTicketRef.current = ticketInfo;
    if (
      ticketInfo?.issueStatus === TICKET_STATUS.UNUSE &&
      ticketInfo?.status === TICKET_STATUS.UNUSE
    ) {
      await onOpenCustomerInfo(ticketInfo, 'release');
    }
  };

  const [triggerScrollTop, setTriggerScrollTop] = useState(false);
  useEffect(() => {
    if (triggerScrollTop) {
      window.scrollTo(0, 0);
      tableRef?.current?.querySelector('.ant-table-body')?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      setTriggerScrollTop(false);
    }
  }, [triggerScrollTop]);
  const getData = (params: I_filter) => {
    const _params: any = {};
    if (
      (!_.isEmpty(params.park) && params.park !== 'All') ||
      _.isNumber(params.park)
    ) {
      _params.park = params.park;
    }
    if (!_.isEmpty(params.orderBy)) {
      _params.orderBy = params.orderBy;
    }
    if (!_.isEmpty(params.orderType)) {
      _params.orderType = params.orderType;
    }
    if (
      (!_.isEmpty(params.status) && params.status !== 'All') ||
      _.isNumber(params.status)
    ) {
      _params.status = params.status;
    }
    if (!_.isEmpty(params.searchOrderId)) {
      _params.searchOrderId = params.searchOrderId;
    }
    if (!_.isEmpty(params.orderDate)) {
      _params.orderDate = params.orderDate;
    }
    if (!_.isEmpty(params.vgsUsageDateToSearch)) {
      _params.vgsUsageDateToSearch = params.vgsUsageDateToSearch;
    }
    if (
      (!_.isEmpty(params.agent) && params.agent !== 'All') ||
      _.isNumber(params.agent)
    ) {
      _params.agent = params.agent;
    }
    if (!_.isEmpty(params.performanceTime)) {
      _params.performanceTime = params.performanceTime;
    }
    if (!_.isEmpty(params.zoneId) || _.isNumber(params.zoneId)) {
      _params.zoneId = params.zoneId;
    }
    if (!_.isEmpty(params.restaurantId) || _.isNumber(params.restaurantId)) {
      _params.restaurantId = params.restaurantId;
    }
    if (!_.isEmpty(params.areaType) && _.isArray(params.areaType)) {
      _params.areaType = params.areaType.join(',');
    }
    if (!_.isEmpty(params.ageType) && _.isArray(params.ageType)) {
      _params.ageType = params.ageType.join(',');
    }
    if (!_.isEmpty(params.orderTypeStr)) {
      _params.orderTypeStr = params.orderTypeStr;
    }
    if (_.isArray(params.product_id)) {
      _params.product_id = params.product_id.join(',');
    }
    if (_.isNumber(params.page)) {
      _params.page = params.page;
    }
    if (_.isNumber(params?.limit)) {
      _params.limit = params.limit;
    }
    if (!_.isEmpty(params?.expiredDateFrom)) {
      _params.expiredDateFrom = params.expiredDateFrom;
    }
    if (!_.isEmpty(params?.expiredDateTo)) {
      _params.expiredDateTo = params.expiredDateTo;
    }
    if (!_.isNil(params?.groupCode)) {
      _params.groupCode = params.groupCode;
    }
    if (!_.isNil(params?.type) && params.type.length > 0) {
      _params.type = Array.isArray(params.type)
        ? params.type.join(',')
        : params.type;
    }
    if (!_.isNil(params?.bpAllocatedDebt)) {
      _params.bpAllocatedDebt = params.bpAllocatedDebt;
    }
    if (!_.isNil(params?.orderSource) && params.orderSource.length > 0) {
      _params.orderSource = params.orderSource;
    }

    selectedTicketRef.current = {
      isActive: false,
      selectedTickets: [],
    };
    selectedOneTicketRef.current = null;
    setIsResetFrom(true);
    setResetSelected(true);
    //
    dispatch(
      GET_TICKETS({
        _params,
        onSuccess: () => setTriggerScrollTop(true),
      }),
    );
  };
  const handleSort = sortKey => {
    setLoading(true);
    setFilters({
      ...filters,
      orderBy: sortKey,
      orderType: filters.orderType === 'DESC' ? 'ASC' : 'DESC',
    });

    getData({
      ...filters,
      orderBy: sortKey,
      orderType: filters.orderType === 'DESC' ? 'ASC' : 'DESC',
    });
    setLoading(false);
  };
  const handleChangePage = (page, sizePage) => {
    setFilters({ ...filters, page, limit: sizePage });
    getData({ ...filters, page, limit: sizePage });
  };

  const handleExportExcel = async () => {
    setLoading(true);
    setFilters({ ...filters });

    try {
      let filterExcel = _.omitBy(
        filters,
        (v: any, k: any) =>
          ['All', undefined, null].includes(v) ||
          ['page', 'limit'].includes(k) ||
          (k === 'orderSource' && !v.length),
      );
      const resExportExcel = await exportExcelApi(filterExcel);
      if (resExportExcel?.data?.success) {
        window.location.href = resExportExcel?.data?.data?.path;
      }
    } catch (error: any) {
      onOpenDialogNoti({
        type: 'ERROR',
        content: error?.message ?? '',
        isShow: true,
        title: '',
        onCloseDialog: onCloseDialogNoti,
      });
    } finally {
      setLoading(false);
    }
  };

  const onSubmitSearh = (paramsFilter: any) => {
    setFilters({ ...paramsFilter, page: 1 });
    getData({ ...paramsFilter, page: 1 });

    selectedTicketRef.current = {
      isActive: false,
      selectedTickets: [],
    };
  };
  useEffect(() => {
    dispatch(GET_PARKS());
    dispatch(GET_ZONES());
    dispatch(GET_RESTAURANTS());
    dispatch(GET_PERFORMANCES());
    if (!_.isEmpty(state)) {
      setFilters({ ...filters, ...state });
      getData({ ...filters, ...state });
      history.replace(pathname);
    } else {
      getData(filters);
    }
  }, []);

  const handleInfoExchange = (ticketInfo: any) => {
    setIsShowTicketExpired(true);
    setTicketDetail(ticketInfo);
    // history.push(`/check-tickets/info-exchange`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const titleColumnSizes = useTitleSize({
    title: [
      'b2b.txt.order-date',
      'b2b.table.PNR',
      'b2b.txt.orderer',
      'b2c.txt.park',
      'b2b.txt.product-code',
      'b2b.txt.product-name',
      'b2b.txt.ticketType',
      'b2b.txt.ticket-code',
      'b2b.txt.ticket-expried',
      'b2b.txt.date-from',
      'b2b.txt.date-to',
      'b2b.txt.ticket-detail',
      'b2b.txt.ticket-status',
      'b2b.txt.used-date',
      'b2b.txt.ticket-issusance-status',
      'b2b.txt.ticket-customer-info',
      'b2b.txt.action',
      'b2b.txt.partner',
      'b2b.txt.source',
      'b2b.txt.sapCode',
    ],
  });

  const columns = [
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.order-date'] : ''}
        </div>
      ),
      key: '1',
      render: dataObject => {
        const newDate = moment(
          dataObject?.orderDate?.datetimeDMYHIS,
          formatString,
        );
        if (newDate.toString() === 'Invalid date')
          return (
            <div
              style={{
                minWidth: titleColumnSizes['b2b.txt.order-date'],
              }}
            />
          );
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.order-date'],
            }}
          >
            <Typography>{newDate.format('DD/MM/YYYY')}</Typography>
            <Typography>{newDate.format('HH:mm:ss')}</Typography>
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          {translations ? translations['b2b.table.PNR'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div
            style={{
              textAlign: 'center',
              minWidth: titleColumnSizes['b2b.table.PNR'],
            }}
            onClick={() =>
              onClickShowDetail(dataObject?.idHash ?? dataObject.orderId)
            }
          >
            <TooltipParagraph
              ellipsis={{ rows: 1 }}
              style={{
                width: 140,
                color: '#F8B117',
                cursor: 'pointer',
                marginBottom: 0,
                textAlign: 'center',
              }}
            >
              {`${
                !!dataObject?.thirdPartySubmitNumber
                  ? dataObject?.thirdPartySubmitNumber
                  : dataObject?.orderId || ''
              }`}
            </TooltipParagraph>
          </div>
        );
      },
      key: '2',
    },
    {
      title: translations?.['b2b.txt.sapCode'],
      key: 'sapSubmitNumber',
      render: ticket => (
        <div
          style={{
            minWidth: titleColumnSizes['b2b.txt.sapCode'],
          }}
        >
          {ticket?.sapSubmitNumber}
        </div>
      ),
    },
    !isProxyBuyer
      ? {
          title: translations?.['b2b.txt.source'],
          key: 'orderSourceName',
          render: data => {
            return (
              <div style={{ minWidth: titleColumnSizes['b2b.txt.source'] }}>
                {data?.orderSourceName ?? ''}
              </div>
            );
          },
        }
      : {},
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.orderer'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.orderer'],
            }}
          >
            <TooltipParagraph
              ellipsis={{ rows: 1 }}
              style={{
                width: 164,
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {dataObject?.agent?.name || ''}
            </TooltipParagraph>
          </div>
        );
      },
      key: '3',
    },
    isProxyBuyer
      ? {
          title: (
            <div style={{ textAlign: 'center' }}>
              {translations?.['b2b.txt.partner']}
            </div>
          ),
          render: value => {
            return (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  minWidth: titleColumnSizes['b2b.txt.partner'],
                }}
              >
                <TooltipParagraph
                  ellipsis={{ rows: 1 }}
                  style={{
                    marginBottom: 0,
                    maxWidth: 164,
                    textAlign: 'center',
                  }}
                >
                  {value?.businessPartnerAllocatedDebt?.name}
                </TooltipParagraph>
              </div>
            );
          },
        }
      : {},
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2c.txt.park'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <>
            <TooltipParagraph
              ellipsis={{ rows: 1 }}
              style={{
                maxWidth: 200,
                minWidth: titleColumnSizes['b2c.txt.park'],
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {!_.isEmpty(dataObject?.park?.name)
                ? dataObject?.park?.name.trim()
                : ''}
            </TooltipParagraph>
          </>
        );
      },
      key: '4',
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.product-code'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.product-code'],
            }}
          >
            {dataObject?.productId || ''}
          </div>
        );
      },
      key: 'productId',
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.product-name'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.product-name'],
            }}
          >
            <TooltipParagraph
              ellipsis={{ rows: 2 }}
              style={{
                maxWidth: 200,
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {!_.isEmpty(dataObject?.product?.name)
                ? dataObject?.product?.name.trim()
                : ''}
            </TooltipParagraph>
          </div>
        );
      },
      key: 'productName',
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.ticketType'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.ticketType'],
            }}
          >
            <TooltipParagraph
              ellipsis={{ rows: 2 }}
              style={{
                maxWidth: 200,
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {convertTicketType(dataObject?.ticketType)}
            </TooltipParagraph>
          </div>
        );
      },
      key: 'ticketType',
    },
    isProxyBuyer
      ? {}
      : {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2b.txt.ticket-code'] : ''}
            </div>
          ),
          render: dataObject => {
            const ticketCodeList = (
              dataObject?.mediaCode ||
              dataObject?.verifyCode ||
              dataObject?.ticketCode ||
              ''
            ).split(',');
            return (
              <div
                style={{
                  textAlign: 'left',
                  minWidth: titleColumnSizes['b2b.txt.ticket-code'],
                }}
              >
                {ticketCodeList.map((code, index) => (
                  <div key={index}>{code}</div>
                ))}
              </div>
            );
          },
          key: 'verifyCode',
        },
    {
      title: (
        <div
          style={{ textAlign: 'left' }}
          onClick={() => handleSort('vgsUsageDate')}
        >
          <div style={{ textAlign: 'left' }}>
            <div style={{ display: 'flex' }}>
              {translations ? translations['b2b.txt.ticket-expried'] : ''}
              <div style={{ marginLeft: 10 }}>
                {filters.orderBy !== 'vgsUsageDate' ? (
                  <SortDefault />
                ) : filters.orderType === 'DESC' ? (
                  <SortDESC />
                ) : (
                  <SortASC />
                )}
              </div>
            </div>
            <div>
              {translations
                ? `(${translations['b2b.txt.date-from']})`
                : '(from)'}
            </div>
          </div>
        </div>
      ),
      render: dataObject => {
        const { fromDate } = getFromDateToDate({
          ...dataObject,
          ticket: {
            vgsUsageDate: dataObject?.vgsUsageDate,
            vgsUsageDateTo: dataObject?.vgsUsageDateTo,
          },
        });
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth:
                Math.max(
                  titleColumnSizes['b2b.txt.ticket-expried'],
                  titleColumnSizes['b2b.txt.date-from'],
                ) + 50,
            }}
          >
            {fromDate}
          </div>
        );
      },
      key: 'dateFrom.datetime',
    },
    {
      title: (
        <div
          style={{ display: 'flex' }}
          onClick={() => handleSort('vgsUsageDateToSearch')}
        >
          <div style={{ textAlign: 'left' }}>
            <div style={{ display: 'flex' }}>
              {translations ? translations['b2b.txt.ticket-expried'] : ''}
              <div style={{ marginLeft: 10 }}>
                {filters.orderBy !== 'vgsUsageDateToSearch' ? (
                  <SortDefault />
                ) : filters.orderType === 'DESC' ? (
                  <SortDESC />
                ) : (
                  <SortASC />
                )}
              </div>
            </div>
            <div>
              {translations ? `(${translations['b2b.txt.date-to']})` : '(to)'}
            </div>
          </div>
        </div>
      ),
      render: dataObject => {
        const { toDate } = getFromDateToDate({
          ...dataObject,
          ticket: {
            vgsUsageDate: dataObject?.vgsUsageDate,
            vgsUsageDateTo: dataObject?.vgsUsageDateTo,
          },
        });
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth:
                Math.max(
                  titleColumnSizes['b2b.txt.ticket-expried'],
                  titleColumnSizes['b2b.txt.date-to'],
                ) + 50,
            }}
          >
            {toDate || ''}
          </div>
        );
      },
      key: 'expiredDate.datetime',
    },
    {
      title: (
        <div>{translations ? translations['b2b.txt.ticket-detail'] : ''}</div>
      ),
      render: dataObject => {
        return (
          <>
            <div
              style={{
                textAlign: 'left',
                minWidth: titleColumnSizes['b2b.txt.ticket-detail'],
              }}
            >
              <Typography>
                {dataObject.ticketDetail
                  ? formatTimeFrame(dataObject.ticketDetail)
                  : ''}
              </Typography>
            </div>
          </>
        );
      },
      key: 'ticket-detail',
    },
    isProxyBuyer
      ? {}
      : {
          title: <div>PDF</div>,
          render: dataObject => {
            const searchParams = new URLSearchParams({
              orderId: dataObject?.idHash,
              orderItemId: dataObject?.orderItemId,
              code: dataObject?.verifyCode ?? dataObject?.ticketCode,
              vgsTicketId: dataObject?.vgsTicketId,
            });
            return (
              <a
                rel="noopener noreferrer"
                href={`/view-pdf/${dataObject?.idHash}?${searchParams}`}
                target="_blank"
                style={{
                  color: dataObject?.isLongTerm ? '#979797' : '#F8B117',
                  fontSize: 14,
                  cursor: 'pointer',
                  display: 'block',
                  minWidth: 100,
                  pointerEvents: !dataObject?.isLongTerm ? 'auto' : 'none',
                }}
              >
                {translations ? translations['b2c.txt.viewPDF'] : ''}
              </a>
            );
          },
          key: 'ticket-detail',
        },
    {
      title: (
        <div>{translations ? translations['b2b.txt.ticket-status'] : ''}</div>
      ),
      render: dataObject => {
        return (
          <div style={{ minWidth: titleColumnSizes['b2b.txt.ticket-status'] }}>
            <StatusComponent
              status={StringStatus(dataObject?.status) as StatusState}
            />
          </div>
        );
      },
      key: 'status',
    },
    {
      title: (
        <div
          style={{ textAlign: 'left', display: 'flex' }}
          onClick={() => handleSort('usageDate')}
        >
          <div>{translations ? translations['b2b.txt.used-date'] : ''} </div>
          <div style={{ marginLeft: 10 }}>
            {filters.orderBy !== 'usageDate' ? (
              <SortDefault />
            ) : filters.orderType === 'DESC' ? (
              <SortDESC />
            ) : (
              <SortASC />
            )}
          </div>
        </div>
      ),
      render: dataObject => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.used-date'] + 50,
            }}
          >
            {dataObject?.usageDate?.dateDMY || ''}
          </div>
        );
      },
      key: 'usageDate.datetime',
    },
    isProxyBuyer
      ? {}
      : {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations
                ? translations['b2b.txt.ticket-issusance-status']
                : ''}{' '}
            </div>
          ),
          render: dataObject => {
            const isIssuaned = +dataObject?.issueStatus === 1;
            const isProxyOrder = !!dataObject?.businessPartnerAllocatedDebt?.id;

            const isDisabled = (() => {
              if (dataObject?.status !== TICKET_STATUS.UNUSE) return true;

              if (isSaleMng || (isProxyOrder && !isProxyBuyer)) return false;
              return dataObject?.agent?.id !== infoUser?.id;
            })();

            return (
              <div
                onClick={e =>
                  isDisabled
                    ? e.preventDefault()
                    : handleSelectedAndReleaseTicket(dataObject)
                }
                style={{
                  display: 'flex',
                  cursor: isDisabled || isIssuaned ? 'default' : 'pointer',
                  justifyContent: 'center',
                  minWidth: titleColumnSizes['b2b.txt.ticket-issusance-status'],
                }}
              >
                {isIssuaned ? (
                  <img
                    src={Images.IssusedIcon}
                    alt="Issused Icon"
                    style={{
                      filter:
                        dataObject.agent?.id !== infoUser?.id &&
                        dataObject?.status !== TICKET_STATUS.UNUSE
                          ? 'contrast(0.75)'
                          : 'current',
                    }}
                  />
                ) : (
                  <UnIssuanedTicketIcon />
                )}
              </div>
            );
          },
          key: '1',
        },
    isProxyBuyer
      ? {}
      : {
          title: (
            <div style={{ textAlign: 'left' }}>
              {translations ? translations['b2b.txt.ticket-customer-info'] : ''}
            </div>
          ),
          render: dataObject => {
            const isProxyOrder = !!dataObject?.businessPartnerAllocatedDebt?.id;

            const isDisabled = (() => {
              if (dataObject?.status !== TICKET_STATUS.UNUSE) return true;

              if (isSaleMng || (isProxyOrder && !isProxyBuyer)) return false;
              return dataObject?.agent?.id !== infoUser?.id;
            })();

            return (
              <div
                onClick={e => {
                  (() => {
                    onOpenCustomerInfo(dataObject);
                    setUpdateInfoTicketId(dataObject?.id);
                    if (dataObject?.issueStatus === '0') {
                      selectedOneTicketRef.current = dataObject;
                    }
                  })();
                }}
              >
                <TooltipParagraph
                  ellipsis={{ rows: 2 }}
                  style={{
                    color: isDisabled ? '#7D7D7D' : '#F8B117',
                    cursor: 'pointer',
                    maxWidth: 200,
                    textAlign: 'left',
                    marginBottom: 0,
                    minWidth: titleColumnSizes['b2b.txt.ticket-customer-info'],
                  }}
                >
                  {`${dataObject?.customerEmail || 'N/A'}`}
                </TooltipParagraph>
              </div>
            );
          },
          key: '2',
        },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.action'] : ''}
        </div>
      ),
      key: '3',
      render: dataObject => {
        const isProxyOrder = !!dataObject?.businessPartnerAllocatedDebt?.id;

        const isDisableRefundTicket = (() => {
          if (+dataObject?.status === 7) return true;

          const isHavePermission =
            (isSaleMng || dataObject.agent?.id === infoUser?.id) &&
            ((isProxyOrder && isProxyBuyer) || !isProxyOrder);
          return (
            !isHavePermission ||
            (dataObject?.status !== TICKET_STATUS.UNUSE &&
              dataObject?.status !== TICKET_STATUS.OUTDATE) ||
            dataObject.ticketType !== 'NORMAL'
          );
        })();

        const isDisableUpgradeTicket = (() => {
          if (+dataObject?.status === 7) return true;

          if (dataObject.ticketType !== 'NORMAL') return true;

          if (isProxyOrder && !isProxyBuyer) return true;

          if (isSaleMng) {
            return dataObject?.status !== TICKET_STATUS.UNUSE;
          }
          return (
            dataObject.agent?.id !== infoUser?.id ||
            dataObject?.status !== TICKET_STATUS.UNUSE
          );
        })();
        const handleRefundTicket = async () => {
          selectedOneTicketRef.current = dataObject;
          await onRefundTicket(true);
        };

        return (
          <div
            style={{
              display: 'flex',
              minWidth: titleColumnSizes['b2b.txt.action'],
            }}
          >
            {infoUser?.businessPartner?.allowChangeTicket && (
              <div
                style={{
                  marginRight: 10,
                  cursor: 'pointer',
                }}
                onClick={e =>
                  isDisableUpgradeTicket
                    ? e.preventDefault()
                    : onUpgradeTicket(dataObject)
                }
              >
                <Tooltip
                  color="white"
                  title={
                    translations ? translations['b2b.txt.ticket-exchange'] : ''
                  }
                  overlayInnerStyle={{ color: 'black' }}
                >
                  {isDisableUpgradeTicket ? (
                    <TicketUpgradeInactiveIcon />
                  ) : (
                    <TicketUpgradeIcon />
                  )}
                </Tooltip>
              </div>
            )}
            {infoUser?.businessPartner?.allowReturnTicket && (
              <div
                style={{
                  cursor: 'pointer',
                }}
              >
                <Tooltip
                  color="white"
                  title={
                    translations ? translations['b2b.txt.ticket-rollback'] : ''
                  }
                  overlayInnerStyle={{ color: 'black' }}
                >
                  <div>
                    {isDisableRefundTicket ? (
                      <TicketRefundInactiveIcon />
                    ) : (
                      <TicketRefundIcon onClick={handleRefundTicket} />
                    )}
                  </div>
                </Tooltip>
              </div>
            )}
            {dataObject.status === TICKET_STATUS.REFUND_EXPIRED && (
              // dataObject.agent?.id === infoUser?.id &&
              <div
                style={{
                  cursor: 'pointer',
                  marginLeft: 10,
                }}
              >
                <Tooltip
                  color="white"
                  title={
                    translations
                      ? translations['b2b.txt.Ticket-exchange-info']
                      : ''
                  }
                  overlayInnerStyle={{ color: 'black' }}
                >
                  <div>
                    <TicketInfoIcon
                      onClick={() => handleInfoExchange(dataObject)}
                    />
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const tableRef = useRef<any>();

  return (
    <Layout
      title={translations ? translations['b2b.txt.check-ticket'] : ''}
      menuActive={ACCOUNT_MNG_MENU.CHECK_TICKET}
    >
      <LoadingContainer loading={loading}>
        <div
          style={{
            display: 'flex',
            flexDirection: device === 'desktop' ? 'column' : 'row',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          {device !== 'desktop' ? (
            <DesktopSearchMobileComponent
              travelLocation={travelLocation}
              filters={filters}
              onSubmitSearh={onSubmitSearh}
              listStatus={listStatus(translations)}
              listOrderTypeStr={listOrderTypeStr(translations)}
              // listZone={listZone}
              listPerformance={listPerformance}
              listRestaurant={listRestaurant}
              listGroupCode={listGroupCode}
              ticketTypeOptions={ticketTypeOptions}
            />
          ) : (
            <DesktopSearchComponent
              travelLocation={travelLocation}
              filters={filters}
              onSubmitSearh={onSubmitSearh}
              listStatus={listStatus(translations)}
              listOrderTypeStr={listOrderTypeStr(translations)}
              // listZone={listZone}
              listPerformance={listPerformance}
              listRestaurant={listRestaurant}
              listGroupCode={listGroupCode}
              ticketTypeOptions={ticketTypeOptions}
            />
          )}
          <ActionComponent
            device={device}
            handleCancelTicket={handleCancelTicket}
            onOpenCustomerInfo={onOpenCustomerInfo}
            handleExportExcel={handleExportExcel}
            selectedTicketRef={selectedTicketRef}
            handleSynTicketStatus={handleSynTicketStatus}
            disabledAllAction={_.isEmpty(listTickets)}
            onUpgradeTicket={onUpgradeTicket}
            onRefundTicket={onRefundTicket.bind(null, false)}
          />
          {errMsg && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                marginBottom: 20,
              }}
            >
              <ErrMsg>{errMsg}</ErrMsg>
            </div>
          )}
        </div>

        <div>
          <StyledTable
            tableRef={tableRef}
            dataSource={
              _.isEmpty(listTickets)
                ? []
                : listTickets.map((ii: any) => ({
                    ...ii,
                    key: ii.id,
                    checkBoxDisable: (() => {
                      const isProxyOrder =
                        !!ii?.businessPartnerAllocatedDebt?.id;
                      if (!isProxyBuyer && isProxyOrder) return false;
                      if (isSaleMng) {
                        return false;
                      } else {
                        return ii.agent?.id !== infoUser?.id;
                      }
                    })(),
                  }))
            }
            columns={columns}
            onSelectChangeCallback={onSelect}
            resetSelected={resetSelected}
            tableProps={{
              pagination: false,
              scroll: {
                y: _.isEmpty(listTickets) ? undefined : '50vh',
                x: _.isEmpty(listTickets) ? 'max-content' : 'auto',
              },
              locale: {
                emptyText: (
                  <EmptyDataView
                    message={
                      translations
                        ? translations['b2b.txt.no-data-check-tickets']
                        : ''
                    }
                  />
                ),
              },
            }}
            styleSlots={{
              antTableContainer: {
                overflow: 'hidden',
              },
              antTableHeader: {
                border: 'none !important',
                borderRadius: '0 !important',
              },
              tableCSS: {
                borderTopLeftRadius: _.isEmpty(listTickets)
                  ? ''
                  : '0 !important',
                borderTopRightRadius: _.isEmpty(listTickets)
                  ? ''
                  : '0 !important',
              },
              antTableBody: {
                paddingBottom: 10,
              },
            }}
          />
        </div>
        {paginator && (
          <>
            <StyledGradientDivider style={{ marginTop: '40px' }} />
            <StyledPagination
              style={{
                marginTop: '40px',
                display: 'flex',
              }}
              showSizeChanger
              defaultCurrent={1}
              pageSizeOptions={['20', '50', '100']}
              current={filters.page}
              total={paginator.totalCount} // Total number of data items
              pageSize={filters.limit} // Number of items per page
              onChange={(page, pageSize) => {
                // window.scrollTo(0, 0);
                filters && handleChangePage(page, pageSize);
              }} // Function to call when the page changes
            />
            <StyledGradientDivider style={{ marginTop: '40px' }} />
          </>
        )}
      </LoadingContainer>
      {isShow && (
        <CustomerInfoModal
          isShow={isShow}
          initCustomerInfo={initCustomerInfo}
          onCloseDialog={onCloseDialog}
          onSumitRelease={onSumitRelease}
          isResetFrom={isResetFrom}
          readOnly={isReadOnlyCustomerInfo}
          selectedTickets={() => {
            let selectedTickets = selectedTicketRef?.current?.selectedTickets;
            if (!_.isEmpty(selectedOneTicketRef?.current)) {
              selectedTickets = [selectedOneTicketRef?.current];
            }
            return selectedTickets;
          }}
        />
      )}
      <TicketExpiredModal
        isShow={isShowTicketExpired}
        ticketInfo={ticketDetail}
        onCloseDialog={onCloseDialog}
      />
      <DialogWarning
        open={!!warningDialogMsg}
        message={warningDialogMsg}
        onClose={() => {
          setWarningDialogMsg('');
        }}
      />
      <DialogCondition
        content={dialogCondition?.content}
        isShow={dialogCondition.isShow}
        onCloseDialog={onCloseDialog}
        onConfirm={onConfirmReplace}
      />
    </Layout>
  );
};

export default CheckTicketComponent;
